import { config } from '../config';
const currentVersion = '1.0';
import axios from 'axios';

export function getChainInfo() {
  return {
    method: 'GET',
    url: `${config.core.walletServiceUrl}/api/chainInfo`,
  };
}

export function getBlockchainConfigurations() {
  return {
    method: 'GET',
    url: `${config.core.walletServiceUrl}/api/blockchain-configurations`,
  };
}

export function getNftCollections() {
  return {
    method: 'GET',
    url: `${config.core.walletServiceUrl}/v${currentVersion}/nft-collections`,
  };
}

export function getNfts({ address, contractAddress, chainId }) {
  return {
    method: 'GET',
    url: `${config.core.walletServiceUrl}/v2.0/nfts/${chainId}/${contractAddress}/${address}`,
  };
}

export function getExternalNfts({ address, chainId }) {
  return {
    method: 'GET',
    url: `${config.core.walletServiceUrl}/api/nfts/external/${chainId}/${address}`,
  };
}

// NFT Submissions
export async function uploadNFTImage({ imageFile, fileName, token }) {
  const base64String = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(imageFile);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = (error) => reject(error);
  });

  const payload = {
    fileData: base64String,
    fileName: fileName,
  };

  const result = await axios({
    method: 'POST',
    url: `${config.core.walletServiceUrl}/v${currentVersion}/ipfs/upload`,
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return result;
}

export function createNFTSubmission({ data }) {
  return {
    method: 'POST',
    url: `${config.core.walletServiceUrl}/v${currentVersion}/nft-collection-submission`,
    data,
  };
}
